import React from 'react';
import PropTypes from 'prop-types';

// Stripe - Modern library
import { Elements } from '@stripe/react-stripe-js';

// Redux
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

// Components
import PayPal from './Paypal';
import StripePayoutForm from './Stripe';
import Megasoft from './Megasoft';

// Stripe Singleton
import { getStripe } from '../../../helpers/stripe';

/**
 * PayoutConfirm - Wrapper component that loads Stripe Elements only when needed
 * 
 * Uses the modern @stripe/react-stripe-js library with lazy loading:
 * - Stripe is only loaded when paymentType === 2 (Stripe payout)
 * - No global Stripe loading in App.js anymore
 * - No memory leaks from setInterval polling
 */
function PayoutConfirm({ paymentType, previousPage, accountData }) {
  // Stripe payout (methodId === 2)
  if (paymentType === 2) {
    return (
      <Elements stripe={getStripe()}>
        <StripePayoutForm previousPage={previousPage} />
      </Elements>
    );
  }
  
  // PayPal payout (methodId === 1)
  if (paymentType === 1) {
    return <PayPal previousPage={previousPage} />;
  }
  
  // Megasoft/Venezuela payout (methodId >= 3)
  return <Megasoft previousPage={previousPage} accountData={accountData} />;
}

PayoutConfirm.propTypes = {
  previousPage: PropTypes.any.isRequired,
  paymentType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  accountData: PropTypes.object
};

const selector = formValueSelector('PayoutForm');

const mapState = (state) => ({
  paymentType: selector(state, 'paymentType'),
  accountData: state.account.data
});

export default connect(mapState)(PayoutConfirm);